import React from 'react';
import { EnergyCodeLanding } from './pages/EnergyCodeLanding';
export function App() {
  return <EnergyCodeLanding data-id="element-0" />;
}